<template>
  <div class="product-list-detail">
    <h3 style="background: #13ce66;color: #fff">已选货品</h3>
    <table class="table">
      <thead>
      <tr>
        <th style="width: 200px">货品</th>
        <th>批号</th>
        <th style="width: 70px">单价</th>
        <th style="width: 70px">数量</th>
        <th style="width: 90px">金额</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="product in goodsList" :key="product.copyGoodsId">
        <td>
          <div v-show="!product.isCopy">
            <span>{{product.goodsName}}</span>
            <div class="f-grey">
              货品编号：{{product.code}}
            </div>
            <div class="f-grey">
              规格：{{product.specifications}}
            </div>
          </div>
        </td>
        <td>
          <template v-if="isNeedOrder">
            <el-select style="width: 180px" v-model="product.storeId" filterable clearable popper-class="custom-select"
                       @focus="queryBatchNumbers(product)" @change="batchNumberIdChange(product)" placeholder="请选择批号">
              <el-option v-for="item in product.batchNumberList" :value="item.storeId" :key="item.storeId"
                         :label="item.batchNumber">
                <div style="line-height: 20px">{{ item.batchNumber }}</div>
                <div class="select-other-info">
                  <div>可用库存:{{item.count}}</div>
                  <div v-show="item.logisticsCentreName">物流中心:{{item.logisticsCentreName}}</div>
                  <div v-show="item.supplyManufacturersName">供货单位:{{item.supplyManufacturersName}}</div>
                  <div v-show="item.expirationDate">有效期:{{item.expirationDate|date}}</div>
                </div>
              </el-option>
            </el-select>
            <div style="padding: 4px 0" >
              <el-button type="primary" size="small" @click="addProduct(product)" v-show="!product.isCopy">添加多批号</el-button>
              <el-button type="danger" size="small" @click="deleteItem(product)" v-show="product.isCopy">删除</el-button>
            </div>
            <div v-show="product.batchNumber && isNeedOrder">
              <div class="f-grey">
                有效期：<span>{{ product.expirationDate | date }}</span>
              </div>
              <div class="f-grey">
                可用库存：<span>{{ product.count }}</span>
              </div>
              <div class="f-grey" v-show="product.supplyManufacturersName">
                供货单位：<span>{{ product.supplyManufacturersName }}</span>
              </div>
              <div class="f-grey" v-show="product.warehouseName">
                仓库地址：<span>{{ product.warehouseName }}</span>
              </div>
              <div class="f-grey" v-show="product.logisticsCentreName">
                物流中心：{{ product.logisticsCentreName }}
              </div>
            </div>
          </template>
          <span v-else>
            {{product.batchNumber}}
             <div class="f-grey">
              生产日期：<span>{{ product.productionDate | date }}</span>
            </div>
             <div class="f-grey">
              有效期：<span>{{ product.expirationDate | date }}</span>
            </div>
          </span>
        </td>
        <td class="ar">
          <span v-show="product.unitPrice">¥</span>{{product.unitPrice | formatMoney}}
        </td>
        <td class="ar">
          <div class="mb-10">
           <span v-show="!product.isCopy"> 该品规需求数：{{product.orderAmount}}
                <span v-show="product.measurementUnit"><dict
                  :dict-group="'measurementUnit'"
                  :dict-key="product.measurementUnit"></dict></span>
           </span>
          </div>
          <el-input type="number" :min="0" v-model="product.amount" style="width: 150px"
                    @input="inputChange(product)"
                    @blur="changeValue(product)">
             <span slot="append" v-show="product.measurementUnit"><dict
               :dict-group="'measurementUnit'"
               :dict-key="product.measurementUnit"></dict></span>
          </el-input>
        </td>
        <td class="ar">
          <span>¥</span>{{ (product.amount || 0) * product.unitPrice | formatMoney }}
        </td>
      </tr>
      <tr>
        <td colspan="5" align="right">
          <span v-show="totalMoney">
            <span style="color: #333;font-weight: 700">合计：</span>
            <span>¥{{ totalMoney | formatMoney }}</span>
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import {BspStock} from '@/resources';

  export default {
    props: {
      goodsList: {
        type: Array,
        default: () => []
      },
      baseForm: Object
    },
    computed: {
      totalMoney: function () {
        let totalMoney = 0.00;
        this.goodsList.forEach(item => {
          totalMoney += (item.amount || 0) * item.unitPrice;
        });
        return totalMoney;
      },
      isNeedOrder() { // 需求订单
        return this.$route.meta.isNeed;
      },
      isPurchaseReturnOrder() { // 采购退货单
        return this.$route.meta.isPurchaseReturn;
      }
    },
    methods: {
      queryBatchNumbers(item) {
        item.batchNumberList = [];
        const params = {
          goodsId: item.goodsId,
          orgId: this.$store.state.user.userCompanyAddress,
          logisticsCentreId: this.baseForm.thirdLogisticsDhsId && this.baseForm.logisticsCentreId || ''
        };
        this.doing = true;
        BspStock.queryOrgStockList(params).then(res => {
          let list  = this.goodsList.filter(f => f.goodsId === item.goodsId && f.copyGoodsId !== item.copyGoodsId);
          res.data.forEach(i => {
            i.isOutDate = i.expiryDate < new Date(this.$moment(Date.now()).format('YYYY-MM-DD')).getTime();
          });
          item.batchNumberList = res.data.filter(f => {
            return !this.baseForm.qualifiedFlag ? f.isOutDate : !f.isOutDate;
          }).filter(f => f.availableCount && !list.some(s => s.storeId === f.id)).map(m => ({
            storeId: m.id,
            productCount: '',
            batchNumber: m.batchNumber,
            batchNumberId: m.batchNumberId,
            count: m.availableCount,
            productionDate: m.productionDate,
            expirationDate: m.expiryDate,
            supplyManufacturersName: m.supplyManufacturersName,
          }));
        });
      },
      batchNumberIdChange(item) {
        item.count = '';
        item.productionDate = '';
        item.expirationDate = '';
        item.batchNumber = '';
        item.batchNumberId = '';
        item.supplyManufacturersName = '';
        item.warehouseCode = '';
        if (!item.storeId) return;
        let batchNumber = item.batchNumberList.find(f => f.storeId === item.storeId);
        if (!batchNumber) return;
        item.count = batchNumber.count;
        item.productionDate = batchNumber.productionDate;
        item.expirationDate = batchNumber.expirationDate;
        item.batchNumber = batchNumber.batchNumber;
        item.batchNumberId = batchNumber.batchNumberId;
        item.supplyManufacturersName = batchNumber.supplyManufacturersName;
        item.warehouseCode = batchNumber.warehouseCode;
      },
      addProduct(item) {
        this.$emit('addItem', item);
      },
      editItem(item) {
        this.$emit('editItem', item);
      },
      deleteItem(item) {
        this.$emit('deleteItem', item);
      },
      changeValue(item) {
        // 销售退货单位不做控制
        if (!this.isPurchaseReturnOrder) return;
        if (item.amount > item.count) {
          this.$notify.warning({
            duration: 2000,
            message: '输入的产品数量大于可用库存'
          });
        }
        if (item.amount < 0) {
          this.$notify.warning({
            duration: 2000,
            message: '输入的产品数量不能为负数'
          });
        }
      },
      inputChange(product) {
        let str = product.amount + '';
        str = product.amount.replace('-', '');
        product.amount = parseInt(str, 10);
      }
    }
  };
</script>
